import { useStyles } from "./MainTag.styles";
import { IMainTag, MainTagTypeEnum } from "./MainTagInterfaces";

const MainTag = ({ children, className, fontBold, type = MainTagTypeEnum.INFO, small }: IMainTag) => {
    const classes = useStyles();
    return (
        <div
            className={`${classes.mainWrapper} ${className ? className : ""} ${classes[type]} ${
                small ? classes.small : ""
            }`}
            style={{
                fontWeight: fontBold ? "bold" : "normal",
            }}
        >
            {children}
        </div>
    );
};

export default MainTag;
